/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { FileDtoFromJSON, FileDtoToJSON, GarageSpotDtoFromJSON, GarageSpotDtoToJSON, } from './';
export function CommonDataGarageDtoFromJSON(json) {
    return CommonDataGarageDtoFromJSONTyped(json, false);
}
export function CommonDataGarageDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'carsCount': !exists(json, 'carsCount') ? undefined : json['carsCount'],
        'photo': !exists(json, 'photo') ? undefined : FileDtoFromJSON(json['photo']),
        'garageSpots': !exists(json, 'garageSpots') ? undefined : (json['garageSpots'] === null ? null : json['garageSpots'].map(GarageSpotDtoFromJSON)),
    };
}
export function CommonDataGarageDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'carsCount': value.carsCount,
        'photo': FileDtoToJSON(value.photo),
        'garageSpots': value.garageSpots === undefined ? undefined : (value.garageSpots === null ? null : value.garageSpots.map(GarageSpotDtoToJSON)),
    };
}
